import Vue from "vue";

const PROGRAM_TEAMS_RESPONSE = "programTeamsResponse";
const PAGE_LOADED_MY_DASHBOARD = "pageLoadedMyDashboard";
const SAVE_PROGRAM_SETTINGS = "saveProgramSettings";

export default new Vue({
  methods: {
    emitProgramTeamsResponse(event) {
      this.$emit(PROGRAM_TEAMS_RESPONSE, event);
    },
    onProgramTeamsResponse(cb) {
      this.$on(PROGRAM_TEAMS_RESPONSE, cb);
    },
    offProgramTeamsResponse() {
      this.$off(PROGRAM_TEAMS_RESPONSE);
    },
    emitPageLoadedMyDashboard(event) {
      this.$emit(PAGE_LOADED_MY_DASHBOARD, event);
    },
    onPageLoadedMyDashboard(cb) {
      this.$on(PAGE_LOADED_MY_DASHBOARD, cb);
    },
    offPageLoadedMyDashboard() {
      this.$off(PAGE_LOADED_MY_DASHBOARD);
    },
    emitSaveProgramSettings(event) {
      this.$emit(SAVE_PROGRAM_SETTINGS, event);
    },
    onSaveProgramSettings(cb) {
      this.$on(SAVE_PROGRAM_SETTINGS, cb);
    },
    offSaveProgramSettings() {
      this.$off(SAVE_PROGRAM_SETTINGS);
    }
  }
});
